import React, { useEffect, useRef, useState } from 'react';
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import ThemeBase from "../../utils/Theme/themeBase";
import TokenService from '../../services/TokenService';
import { urlTelerik } from '../../services/http-common';
import reporteServicio from '../../services/reporteService';
import AuthService from '../../services/AuthService';
import { Spinner, SpinnerSize, Stack } from '@fluentui/react';

const CuadroMandoGenerico = ({
    NameReport,
    parameters,
    reportServiceUrl,
    viewerContainerStyle,
    scaleMode,
    scale,
    enableAccessibility
}) => {
    // Creamos una referencia para el ReportViewer
    // const viewerRef = useRef(null);
    let viewer;
    const [tokAut, setTokAut] = useState(TokenService.getToken());
    const [mostrarReporte, setMostrarReporte] = useState(false);


    // Configuración para el reporte
    const reportViewerSettings = {
        serviceUrl: reportServiceUrl || urlTelerik,
        reportSource: {
            report: NameReport,  // El archivo .trdp que contiene el reporte
            parameters: parameters,  // Los parámetros que serán pasados al reporte
        },
        viewerContainerStyle: viewerContainerStyle || ThemeBase.telerikStyle,  // Estilo personalizado para el contenedor
        scaleMode: scaleMode || 'SPECIFIC',  // Modo de escala (por defecto SPECIFIC)
        scale: scale || 1.0,  // Escala del reporte (por defecto 1.0)
        enableAccessibility: enableAccessibility || false,  // Habilitar accesibilidad (por defecto false)
    };

    const [key, setKey] = useState(0);

    const recargarComponente = () => {
        setKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
        const hideExportButton = () => {
            const exportButton: any = document.querySelector("#trv-main-menu-export-command");
            // console.log(exportButton)

            if (exportButton) {
                // console.log(exportButton)
                exportButton.remove();
                // exportButton.style.display = 'none';
                clearInterval(interval);
            }
        };

        // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
        // const interval = setInterval(hideExportButton, 1);
        const interval = setInterval(hideExportButton, 100);

        // Limpia el intervalo al desmontar el componente
        return () => clearInterval(interval);
    }, [key]);


    useEffect(() => {

        reporteServicio.version()
            .then((response) => {
                if (response.status === 401) {
                    // Configura el retraso de 2 segundos
                    const timer = setTimeout(() => {
                        setTokAut(TokenService.getToken());
                        //recargarComponente()
                        setMostrarReporte(true)
                    }, 1000); // 1000 ms = 1 segundo

                }
                if (response.status === 200) {
                    setTokAut(TokenService.getToken());
                    setMostrarReporte(true)
                    //recargarComponente()
                }
                else {
                    console.error("Status:", response.status);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }, []);

    useEffect(() => {
        if (!AuthService.verifiedExp() && mostrarReporte) {
            recargarComponente();
        }
    }, [tokAut, mostrarReporte]);

    return (
        <>
            {mostrarReporte ? (
                // <div key={key} style={{ height: '100vh', width: '100%' }}>
                <div style={{ height: '100vh', width: '100%' }}>
                    <TelerikReportViewer
                        // ref={viewerRef}  // Pasamos la referencia
                        // ref={el => viewer = el}
                        serviceUrl={reportViewerSettings.serviceUrl}
                        reportSource={reportViewerSettings.reportSource}
                        viewerContainerStyle={reportViewerSettings.viewerContainerStyle}
                        scaleMode={reportViewerSettings.scaleMode}
                        scale={reportViewerSettings.scale}
                        enableAccessibility={reportViewerSettings.enableAccessibility}
                        authenticationToken={tokAut}
                    />
                </div>
            ) : (
                <div>
                    {/* <Stack tokens={ThemeTitleBase.stackTokens}> */}
                    <Stack>
                        <Spinner style={{
                            display: 'flex',
                            top: '50%',
                            left: '45%',
                            height: '100vh',
                            zIndex: '1000',
                            color: 'yellow'
                        }} size={SpinnerSize.medium} label={`Cargando reporte...`} />
                    </Stack>
                </div>
            )}

        </>
    );
};

export default CuadroMandoGenerico;